/**
 * Matrícula e código do contrato podem faltar no Axiis (colunas nullable): sem
 * eles, fica só o nome — mesma regra das planilhas exportadas pelo back.
 */
export function professionalLabel(professional: {
  registrationNumber: number | null;
  name: string;
}): string {
  const name = professional.name.trim();
  return professional.registrationNumber === null
    ? name
    : `${professional.registrationNumber} · ${name}`;
}

export function contractLabel(contract: { contractCode: number | null; name: string }): string {
  return contract.contractCode === null
    ? contract.name
    : `${contract.contractCode} - ${contract.name}`;
}

export function labelWithIso(label: string, iso: string | undefined | null): string {
  return iso ? `${label} (${iso})` : label;
}
